import React from 'react';
import { JiraSoftwareIcon } from '@atlaskit/logo';
import { B200, B400, N900 } from '@atlaskit/theme/colors';
import styled from 'styled-components';
import { ProductIconPropsType, ICON_STATES } from '../../model';
import { useFreeBundlesData } from '../../hooks';

export function ProductIcon({ productKey, iconState }: ProductIconPropsType) {
  const { productData } = useFreeBundlesData();
  if (
    !productData ||
    !productData[productKey] ||
    !productData[productKey].productIconUrl
  ) {
    switch (iconState) {
      case ICON_STATES.PRIMARY_PRODUCT:
        return (
          <StyledPrimaryProductJiraSoftwareIcon
            size={'xlarge'}
            iconColor={B200}
            textColor={N900}
            iconGradientStart={B400}
            iconGradientStop={B200}
          />
        );
      case ICON_STATES.SECONDARY_PRODUCT:
        return (
          <StyledSecondaryProductJiraSoftwareIcon
            size={'xlarge'}
            iconColor={B200}
            textColor={N900}
            iconGradientStart={B400}
            iconGradientStop={B200}
          />
        );
      case ICON_STATES.MODAL_PRODUCT:
        return (
          <StyledSecondaryProductJiraSoftwareIcon
            size={'medium'}
            iconColor={B200}
            textColor={N900}
            iconGradientStart={B400}
            iconGradientStop={B200}
          />
        );
      case ICON_STATES.PRODUCT_ADDED:
        return (
          <StyledSecondaryProductJiraSoftwareIcon
            size={'large'}
            iconColor={B200}
            textColor={N900}
            iconGradientStart={B400}
            iconGradientStop={B200}
          />
        );
    }
  } else {
    switch (iconState) {
      case ICON_STATES.PRIMARY_PRODUCT:
        return (
          <PrimaryProductIcon src={productData[productKey].productIconUrl} />
        );
      case ICON_STATES.SECONDARY_PRODUCT:
        return (
          <SecondaryProductIcon src={productData[productKey].productIconUrl} />
        );
      case ICON_STATES.MODAL_PRODUCT:
        return (
          <ModalProductIcon src={productData[productKey].productIconUrl} />
        );
      case ICON_STATES.MODAL_PRODUCT:
        return (
          <ProductAddedIcon src={productData[productKey].productIconUrl} />
        );
    }
  }
  return (
    <StyledPrimaryProductJiraSoftwareIcon
      size={'xlarge'}
      iconColor={B200}
      textColor={N900}
      iconGradientStart={B400}
      iconGradientStop={B200}
    />
  );
}

const PrimaryProductIcon = styled.img`
  width: 100px;
  margin: 0 8px;

  @media (max-width: 1130px) {
    width: 60px;
  }

  @media (max-width: 510px) {
    width: 48px;
  }
`;

const SecondaryProductIcon = styled.img`
  width: 48px;
  margin: 0px 4px 0px 0px;
`;

const ModalProductIcon = styled.img`
  width: 24px;
  margin: 0 4px 0 0;
`;

const ProductAddedIcon = styled.img`
  width: 32px;
  margin: 0 4px 0 0;
`;

export const StyledSecondaryProductJiraSoftwareIcon = styled(JiraSoftwareIcon)`
  margin: 0 4px 0 0;
`;

export const StyledPrimaryProductJiraSoftwareIcon = styled(JiraSoftwareIcon)`
  width: 100px;
  height: 100px;
  margin: 0 8px;

  & > svg {
    width: 100px;
    height: 100px;
  }
`;
